import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../Header/Images/RMB-Strip-Jaipur.png";
import Userdashbord from './Dashbord/Userdashbord';

import { MdSpaceDashboard, MdRateReview, MdPostAdd } from 'react-icons/md';
import { RiLogoutBoxLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";

import { PiFileLockBold } from "react-icons/pi";


import { RxActivityLog } from "react-icons/rx";

import { IoMdSearch } from "react-icons/io";
import { MdOutlineCalendarMonth } from "react-icons/md";

import { GiNewspaper } from "react-icons/gi";

import { GoGoal } from "react-icons/go";

import { SiSecurityscorecard } from "react-icons/si";


import Profile from './Profile/Profile';
import News from './News/News';
import Goals from './Goals/Goals';
import Activity from './Activity/Activity';


interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  expire:string;
}

const MemberPortal = () => {
  const [userId, setUserId] = useState<string | null>(null);
  const navigate = useNavigate();
  const[bannerMenu,setBannerMenu] = useState<Boolean>(false);
    const[pageMenu,setPageMenu] = useState<Boolean>(false);
   const[tabs, setTabs]  = useState<string>("Dashbord");

   const [menuOpen, setMenuOpen] = useState(false);

  
   return (
    <div className="flex">
  {/* Sidebar Menu */}
  <div
    className={`fixed lg:static top-0 left-0 bg-darkblue min-h-screen w-[70%] lg:w-[21%]  transform lg:translate-x-0 transition-transform duration-300 ${
      menuOpen ? "translate-x-0" : "-translate-x-full"
    } z-20`}
  >
    <div className="flex flex-col items-center justify-start py-4 gap-3 h-screen overflow-hidden">
      <div className="w-[230px]">
        <img
          src={logo}
          alt="Logo"
          className="rounded-lg drop-shadow-2xl bg-white p-2"
        />
      </div>
      <div className="w-full overflow-y-auto pt-12">
        <MenuItem
          label="Home"
          activeTab={tabs}
          tabKey="Dashbord"
          icon={<MdSpaceDashboard />}
          onClick={() => setTabs("Dashbord")}
        />
         <MenuItem
          label="Profile"
          activeTab={tabs}
          tabKey="Profile"
          icon={<CgProfile />}
          onClick={() => setTabs("Profile")}
        />
        <MenuItem
          label="Activity Log"
          activeTab={tabs}
          tabKey="Activity"
          icon={<RxActivityLog />}
          onClick={() => setTabs("Activity")}
        />
        <MenuItem
          label="Meetings"
          activeTab={tabs}
          tabKey="Meetings"
          icon={<MdRateReview />}
          onClick={() => setTabs("Meetings")}
        />
       
        
       
        <MenuItem
          label="Chapter Goals"
          activeTab={tabs}
          tabKey="Chapter"
          icon={<GoGoal />}
          onClick={() => setTabs("Chapter")}
        />
        
        
        <MenuItem
          label="Logout"
          activeTab={tabs}
          tabKey="Logout"
          icon={<RiLogoutBoxLine />}
          onClick={() => (window.location.href = "/login")}
        />
      </div>
    </div>
  </div>

  {/* Header for Mobile */}
  <div className="lg:hidden bg-darkblue text-white px-4 py-3 flex items-center justify-between fixed top-0 left-0 w-full z-10">
      <img src={logo} alt="Logo" className="w-[50%] object-contain drop-shadow-2xl" />
      <button
        className="relative w-8 h-8 focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {/* Animated Hamburger Icon */}
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "rotate-45 translate-y-[10px]" : ""
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded my-[6px] transition-opacity duration-300 ${
            menuOpen ? "opacity-0" : "opacity-100"
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "-rotate-45 -translate-y-[10px]" : ""
          }`}
        ></div>
      </button>
    </div>

  {/* Overlay for Small Screens */}
  {menuOpen && (
    <div
      className="fixed inset-0 bg-black opacity-50 z-10 lg:hidden"
      onClick={() => setMenuOpen(false)}
    />
  )}

  {/* Content Section */}
  <div className="pt-[60px] lg:pt-0 ml-0  w-full  bg-[#CBD5E0] min-h-screen transition-all">
 
    {tabs === "Meetings" && <News/>}

    {tabs === "Dashbord" && <Userdashbord />}
    {tabs === "Chapter" && <Goals />}
    {tabs === "Profile" && <Profile />}
    {tabs === "Activity" && <Activity />}
  </div>
</div>

  );
};

type MenuItemProps = {
  label: string;
  activeTab: string;
  tabKey: string;
  icon: React.ReactNode; // Type for JSX/React components
  onClick: () => void;   // Type for a function with no arguments and no return value
};
const MenuItem: React.FC<MenuItemProps> = ({ label, activeTab, tabKey, icon, onClick }) => (
  <div
    className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
      activeTab === tabKey ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
    }`}
    onClick={onClick}
  >
    <div className="text-2xl">{icon}</div> <h5>{label}</h5>
  </div>
);



export default MemberPortal;
